__turbopack_context__.v({
  "action": "Jt5vFq_action",
  "actions": "Jt5vFq_actions",
  "autoHeight": "Jt5vFq_autoHeight",
  "autoInner": "Jt5vFq_autoInner",
  "avatar": "Jt5vFq_avatar",
  "body": "Jt5vFq_body",
  "comment": "Jt5vFq_comment",
  "composer": "Jt5vFq_composer",
  "composerActions": "Jt5vFq_composerActions",
  "composerArea": "Jt5vFq_composerArea",
  "count": "Jt5vFq_count",
  "deleted": "Jt5vFq_deleted",
  "deletedDot": "Jt5vFq_deletedDot",
  "emoji": "Jt5vFq_emoji",
  "empty": "Jt5vFq_empty",
  "field": "Jt5vFq_field",
  "fieldWrap": "Jt5vFq_fieldWrap",
  "footer": "Jt5vFq_footer",
  "ghost": "Jt5vFq_ghost",
  "header": "Jt5vFq_header",
  "heading": "Jt5vFq_heading",
  "iconAction": "Jt5vFq_iconAction",
  "item": "Jt5vFq_item",
  "list": "Jt5vFq_list",
  "main": "Jt5vFq_main",
  "mention": "Jt5vFq_mention",
  "meta": "Jt5vFq_meta",
  "name": "Jt5vFq_name",
  "prompt": "Jt5vFq_prompt",
  "reaction": "Jt5vFq_reaction",
  "reactions": "Jt5vFq_reactions",
  "reopen": "Jt5vFq_reopen",
  "replies": "Jt5vFq_replies",
  "repliesWrap": "Jt5vFq_repliesWrap",
  "replying": "Jt5vFq_replying",
  "replyingInner": "Jt5vFq_replyingInner",
  "replyingName": "Jt5vFq_replyingName",
  "resolve": "Jt5vFq_resolve",
  "resolved": "Jt5vFq_resolved",
  "resolvedIcon": "Jt5vFq_resolvedIcon",
  "resolvedMeta": "Jt5vFq_resolvedMeta",
  "resolvedSubject": "Jt5vFq_resolvedSubject",
  "resolvedText": "Jt5vFq_resolvedText",
  "resolvedTitle": "Jt5vFq_resolvedTitle",
  "root": "Jt5vFq_root",
  "send": "Jt5vFq_send",
  "stack": "Jt5vFq_stack",
  "subtitle": "Jt5vFq_subtitle",
  "suggestion": "Jt5vFq_suggestion",
  "suggestions": "Jt5vFq_suggestions",
  "thread": "Jt5vFq_thread",
  "time": "Jt5vFq_time",
  "title": "Jt5vFq_title",
  "toggle": "Jt5vFq_toggle",
  "toggleIcon": "Jt5vFq_toggleIcon",
});
